export const ActionTypes = {
  GET_CLAIM: "GET_CLAIM",
  GET_CLAIM_RESULTS: "GET_CLAIM_RESULTS",
  GET_FORMULARY: "GET_FORMULARY",
  GET_FORMULARY_RESULTS: "GET_FORMULARY_RESULTS",
  GET_FORMULARY_LIST: "GET_FORMULARY_LIST",
  GET_FORMULARY_LIST_RESULTS: "GET_FORMULARY_LIST_RESULTS",
  GET_PLAN: "GET_PLAN",
  GET_PLAN_FAILURE: "GET_PLAN_FAILURE",
  GET_PLAN_SUCCESS: "GET_PLAN_SUCCESS",
  SEARCH_FOR_AGREEMENT: "SEARCH_FOR_AGREEMENT",
  SEARCH_FOR_AGREEMENT_RESULTS: "SEARCH_FOR_AGREEMENT_RESULTS",
  SEARCH_FOR_CLAIM: "SEARCH_FOR_CLAIM",
  SEARCH_FOR_CLAIM_RESULTS: "SEARCH_FOR_CLAIM_RESULTS",
  SEARCH_FOR_MEMBER: "SEARCH_FOR_MEMBER",
  SEARCH_FOR_MEMBER_RESULTS: "SEARCH_FOR_MEMBER_RESULTS",
  SEARCH_FOR_NETWORK_LIST: "SEARCH_FOR_NETWORK_LIST",
  SEARCH_FOR_NETWORK_LIST_RESULTS: "SEARCH_FOR_NETWORK_LIST_RESULTS",
  SEARCH_FOR_PLAN_BENEFIT_LIST: "SEARCH_FOR_PLAN_BENEFIT_LIST",
  SEARCH_FOR_PLAN_BENEFIT_LIST_RESULTS: "SEARCH_FOR_PLAN_BENEFIT_LIST_RESULTS",
  SEARCH_FOR_PHARMACY_LIST: "SEARCH_FOR_PHARMACY_LIST",
  SEARCH_FOR_PHARMACY_LIST_RESULTS: "SEARCH_FOR_PHARMACY_LIST_RESULTS",
  SEARCH_FOR_PLAN_LIST: "SEARCH_FOR_PLAN_LIST",
  SEARCH_FOR_PLAN_LIST_RESULTS: "SEARCH_FOR_PLAN_LIST_RESULTS",
  SEARCH_FOR_USER_PERMISSIONS: "SEARCH_FOR_USER_PERMISSIONS",
  SEARCH_FOR_USER_PERMISSIONS_RESULTS: "SEARCH_FOR_USER_PERMISSIONS_RESULTS",
  SEARCH_FOR_AGREEMENT_PRICING_LIST: "SEARCH_FOR_AGREEMENT_PRICING_LIST",
  SEARCH_FOR_AGREEMENT_PRICING_LIST_RESULTS: "SEARCH_FOR_AGREEMENT_PRICING_LIST_RESULTS",
  SEARCH_FOR_AGREEMENT_CUSTOM_PRICING_LIST: "SEARCH_FOR_AGREEMENT_CUSTOM_PRICING_LIST",
  SEARCH_FOR_AGREEMENT_CUSTOM_PRICING_LIST_RESULTS: "SEARCH_FOR_AGREEMENT_CUSTOM_PRICING_LIST_RESULTS",
  CREATE_NETWORK: "CREATE_NETWORK",
  GET_PLAN_ACCOUNT: "GET_PLAN_ACCOUNT",
  GET_PLAN_ACCOUNT_RESULTS: "GET_PLAN_ACCOUNT_RESULTS",
  GET_MEMBER_INFORMATION: "GET_MEMBER_INFORMATION",
  GET_MEMBER_INFORMATION_RESULTS: "GET_MEMBER_INFORMATION_RESULTS",
  CLEAR_GROUP: "CLEAR_GROUP",
  GET_GROUP: "GET_GROUP",
  GET_GROUP_RESULTS: "GET_GROUP_RESULTS",
  NETWORK_LIST_RESULTS_RECEIVED: "NETWORK_LIST_RESULTS_RECEIVED",
  UPDATE_NETWORK_ATTACHMENTS: "UPDATE_NETWORK_ATTACHMENTS",
  UPDATE_NETWORK_DETAILS: "UPDATE_NETWORK_DETAILS",
  LIST_NETWORK_ATTACHMENTS_EXCLUDE: "LIST_NETWORK_ATTACHMENTS_EXCLUDE",
  GET_PRICE_LIST_LIST: "GET_PRICE_LIST_LIST",
  GET_PRICE_LIST_LIST_RESULTS: "GET_PRICE_LIST_LIST_RESULTS",
  GET_FORMULARY_FILES_LIST: "GET_FORMULARY_FILES_LIST",
  GET_FORMULARY_FILES_LIST_RESULTS: "GET_FORMULARY_FILES_LIST_RESULTS",
  UPLOAD_FORMULARY_FILE: "UPLOAD_FORMULARY_FILE",
  CLEAR_AGREEMENT_PRICING: "CLEAR_AGREEMENT_PRICING",
  SET_PRICING_CATEGORY: "SET_PRICING_CATEGORY",
  SET_CLASSIFICATION_LIST: "SET_CLASSIFICATION_LIST",
  CLEAR_PRICING_CATEGORY: "CLEAR_PRICING_CATEGORY",
  SEARCH_FOR_DRUG: "SEARCH_FOR_DRUG",
  SEARCH_FOR_DRUG_RESULTS: "SEARCH_FOR_DRUG_RESULTS",
  SEARCH_FOR_SELECTED_DRUGS: "SEARCH_FOR_SELECTED_DRUGS",
  SEARCH_FOR_SELECTED_DRUGS_RESULTS: "SEARCH_FOR_SELECTED_DRUGS_RESULTS",
  ADD_SELECTED_DRUG: "ADD_SELECTED_DRUG",
  ADD_CURRENT_SELECTED_DRUG: "ADD_CURRENT_SELECTED_DRUG",
  REMOVE_SELECTED_DRUG: "REMOVE_SELECTED_DRUG",
  CREATE_PRICING_LEVEL: "CREATE_PRICING_LEVEL",
  UPDATE_PRICING_LEVEL: "UPDATE_PRICING_LEVEL",
  GET_PRICING_LEVEL: "GET_PRICING_LEVEL",
  LIST_PRICING_LEVELS: "LIST_PRICING_LEVELS",
  CREATE_PRICING_LEVEL_RESULTS: "CREATE_PRICING_LEVEL_RESULTS",
  UPDATE_PRICING_LEVEL_RESULTS: "UPDATE_PRICING_LEVEL_RESULTS",
  GET_PRICING_LEVEL_RESULTS: "GET_PRICING_LEVEL_RESULTS",
  LIST_PRICING_LEVELS_RESULTS: "LIST_PRICING_LEVELS_RESULTS",
  GET_PHARMACY: "GET_PHARMACY",
  GET_PHARMACY_RESULTS: "GET_PHARMACY_RESULTS",
  GET_BATCH_TRANSMISSION_TEST_CLAIM: "GET_BATCH_TRANSMISSION_TEST_CLAIM",
  GET_BATCH_TRANSMISSION_TEST_CLAIM_RESULTS: "GET_BATCH_TRANSMISSION_TEST_CLAIM_RESULTS",
  GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST: "GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST",
  GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST_RESULTS: "GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST_RESULTS",
  DOWNLOAD_BATCH_TRANSMISSION_TEST_CLAIM: "DOWNLOAD_BATCH_TRANSMISSION_TEST_CLAIM",
  UPLOAD_BATCH_TRANSMISSION_TEST_CLAIM_BATCH: "UPLOAD_BATCH_TRANSMISSION_TEST_CLAIM_BATCH",
  SUBMIT_TRANSMISSION_TEST: "SUBMIT_TRANSMISSION_TEST",
  TRANSMISSION_TEST_RESULT: "TRANSMISSION_TEST_RESULT",
  SUBMIT_TRANSMISSION_TEST_AS_BATCH: "SUBMIT_TRANSMISSION_TEST_AS_BATCH",
  GET_BATCH_TRANSMISSION_MANUAL_CLAIM: "GET_BATCH_TRANSMISSION_MANUAL_CLAIM",
  GET_BATCH_TRANSMISSION_MANUAL_CLAIM_RESULTS: "GET_BATCH_TRANSMISSION_MANUAL_CLAIM_RESULTS",
  GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST: "GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST",
  GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST_RESULTS: "GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST_RESULTS",
  DOWNLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM: "DOWNLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM",
  UPLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM_BATCH: "UPLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM_BATCH",
  SUBMIT_TRANSMISSION_MANUAL: "SUBMIT_TRANSMISSION_MANUAL",
  TRANSMISSION_MANUAL_RESULT: "TRANSMISSION_MANUAL_RESULT",
  GET_USER_PERMISSIONS: "GET_USER_PERMISSIONS",
  GET_USER_PERMISSIONS_RESULTS: "GET_USER_PERMISSIONS_RESULTS",
  CREATE_USER: "CREATE_USER",
  SEARCH_FOR_PERMISSION_GROUP: "SEARCH_FOR_PERMISSION_GROUP",
  SEARCH_FOR_PERMISSION_GROUP_RESULT: "SEARCH_FOR_PERMISSION_GROUP_RESULT",
  LIST_CURRENT_GROUP_MEMBERSHIPS: "LIST_CURRENT_GROUP_MEMBERSHIPS",
  LIST_CURRENT_GROUP_MEMBERSHIPS_RESULT: "LIST_CURRENT_GROUP_MEMBERSHIPS_RESULT",
  UPDATE_LOCAL_GROUP_MEMBERSHIPS: "UPDATE_LOCAL_GROUP_MEMBERSHIPS",
  UPDATE_USER: "UPDATE_USER",
  GET_USER_INFORMATION: "GET_USER_INFORMATION",
  GET_USER_INFORMATION_RESULT: "GET_USER_INFORMATION_RESULT",
  VERIFY_USER: "VERIFY_USER",
  RESET_VERIFY_USER_FORM: "RESET_VERIFY_USER_FORM",
  VERIFY_USER_SUCCESS: "VERIFY_USER_SUCCESS",
  VALIDATE_TOKEN: "VALIDATE_TOKEN",
  VALIDATE_TOKEN_SUCCESS: "VALIDATE_TOKEN_SUCCESS",
  GET_MONTHLY_REPORT_JSON: "GET_MONTHLY_REPORT_JSON",
  GET_QUARTERLY_REPORT_JSON: "GET_QUARTERLY_REPORT_JSON",
  PENDING_REPORT_JSON: "PENDING_REPORT_JSON",
  GET_MONTHLY_REPORT_JSON_RESULTS: "GET_MONTHLY_REPORT_JSON_RESULTS",
  SEARCH_FOR_INVOICES: "SEARCH_FOR_INVOICES",
  SEARCH_FOR_INVOICES_RESULTS: "SEARCH_FOR_INVOICES_RESULTS",
  SEARCH_FOR_INVOICES_FAILURE: "SEARCH_FOR_INVOICES_FAILURE",
  SEARCH_FOR_INVOICE_TEMPLATES: "SEARCH_FOR_INVOICE_TEMPLATES",
  SEARCH_FOR_INVOICE_TEMPLATES_RESULTS: "SEARCH_FOR_INVOICE_TEMPLATES_RESULTS",
  SEARCH_FOR_INVOICE_TEMPLATES_FAILURE: "SEARCH_FOR_INVOICE_TEMPLATES_FAILURE",
  BATCH_CREATE_INVOICES: "BATCH_CREATE_INVOICES",
  BUNDLE_INVOICES_ACTION_DOWNLOAD: "BUNDLE_INVOICES_ACTION_DOWNLOAD",
  BUNDLE_INVOICES_ACTION_REGENERATE: "BUNDLE_INVOICES_ACTION_REGENERATE",
  BUNDLE_INVOICES_ACTION_DELETE: "BUNDLE_INVOICES_ACTION_DELETE",
  BUNDLE_INVOICES_ACTION_EMAIL: "BUNDLE_INVOICES_ACTION_EMAIL",
  DOWNLOAD_INVOICE_REPORT: "DOWNLOAD_INVOICE_REPORT",
  DOWNLOAD_INVOICE_REPORT_BUNDLE: "DOWNLOAD_INVOICE_REPORT_BUNDLE",
  DOWNLOAD_INVOICE_REPORT_RESULT: "DOWNLOAD_INVOICE_REPORT_RESULT",
  DOWNLOAD_INVOICE_REPORT_BUNDLE_RESULT: "DOWNLOAD_INVOICE_REPORT_BUNDLE_RESULT",
  CREATE_INVOICE_TEMPLATE: "CREATE_INVOICE_TEMPLATE",
  UPDATE_INVOICE_TEMPLATE: "UPDATE_INVOICE_TEMPLATE",
  GET_INVOICE_TEMPLATE: "GET_INVOICE_TEMPLATE",
  GET_INVOICE_TEMPLATE_RESULT: "GET_INVOICE_TEMPLATE_RESULT",
  GET_QUARTERLY_REPORT_JSON_RESULTS: "GET_QUARTERLY_REPORT_JSON_RESULTS",
  RESEND_PASSWORD: "RESEND_PASSWORD",
  RESEND_PASSWORD_RESULT: "RESEND_PASSWORD_RESULT",
  RESET_MFA: "RESET_MFA",
  RESET_MFA_RESULT: "RESET_MFA_RESULT",
  GET_USER_CONTEXT: "GET_USER_CONTEXT",
  GET_USER_CONTEXT_RESULT: "GET_USER_CONTEXT_RESULT",
  USER_CONTEXT_LOADED: "USER_CONTEXT_LOADED",
  SET_USER_CONTEXT_RESULT: "SET_USER_CONTEXT_RESULT",
  GET_PRODUCT_LIST: "GET_PRODUCT_LIST",
  GET_PRODUCT_LIST_RESULTS: "GET_PRODUCT_LIST_RESULTS",
  PHARMACY_FINANCE_GROUPS_LIST: "PHARMACY_FINANCE_GROUPS_LIST",
  PHARMACY_FINANCE_GROUPS_LIST_RESULTS: "PHARMACY_FINANCE_GROUPS_LIST_RESULTS",
  CREATE_PHARMACY_FINANCE_GROUP: "CREATE_PHARMACY_FINANCE_GROUP",
  GET_PROPOSE_CALENDAR: "GET_PROPOSE_CALENDAR",
  GET_PROPOSE_CALENDAR_RESULT: "GET_PROPOSE_CALENDAR_RESULT",
  GET_PHARMACY_FINANCE_GROUP: "GET_PHARMACY_FINANCE_GROUP",
  GET_PHARMACY_FINANCE_GROUP_RESULT: "GET_PHARMACY_FINANCE_GROUP_RESULT",
  UPDATE_PHARMACY_FINANCE_GROUP: "UPDATE_PHARMACY_FINANCE_GROUP",
  UPDATE_PHARMACY_FINANCE_GROUP_RESULT: "UPDATE_PHARMACY_FINANCE_GROUP_RESULT",
  ATTACH_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT: "ATTACH_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT",
  DETTACH_PFG_PROVIDER_AGREEMENT: "DETTACH_PFG_PROVIDER_AGREEMENT",
  SEARCH_FOR_REMITTANCE: "SEARCH_FOR_REMITTANCE",
  SEARCH_FOR_REMITTANCE_RESULTS: "SEARCH_FOR_REMITTANCE_RESULTS",
  APPROVE_835_REMITTANCE: "APPROVE_835_REMITTANCE",
  DOWNLOAD_835_REMITTANCE: "DOWNLOAD_835_REMITTANCE",
  GET_INVOICE: "GET_INVOICE",
  GET_INVOICE_RESULTS: "GET_INVOICE_RESULTS",
  UPDATE_INVOICE: "UPDATE_INVOICE",
  CLEAR_INVOICE: "CLEAR_INVOICE",
  DUPLICATE_INVOICE_TEMPLATE_CONFIG: "DUPLICATE_INVOICE_TEMPLATE_CONFIG",
  GET_PHARMACY_FINANCE_GROUP_AGREEMENTS: "GET_PHARMACY_FINANCE_GROUP_AGREEMENTS",
  GET_PHARMACY_FINANCE_GROUP_AGREEMENTS_RESULTS: "GET_PHARMACY_FINANCE_GROUP_AGREEMENTS_RESULTS",
  CLEAR_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT: "CLEAR_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT",
  DETACH_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT: "DETACH_PHARMACY_FINANCE_GROUP_PROVIDER_AGREEMENT",
  UPLOAD_DELIVERY_INFORMATION_FILE: "UPLOAD_DELIVERY_INFORMATION_FILE",
  UPLOAD_VENDOR_ID_FILE: "UPLOAD_VENDOR_ID_FILE",
  UPLOAD_CHECK_INJECTION_FILE: "UPLOAD_PAYMENT_INFORMATION_FILE",
  MIGRATE_USER: "MIGRATE_USER",
  MIGRATE_USER_INFORMATION: "MIGRATE_USER_INFORMATION",
  MIGRATE_USER_RESULT: "MIGRATE_USER_RESULT",
  GET_INVOICE_SEGMENT_BY_REPORT_COLUMNS: "GET_INVOICE_SEGMENT_BY_REPORT_COLUMNS",
  GET_INVOICE_SEGMENT_BY_REPORT_COLUMNS_RESULTS: "GET_INVOICE_SEGMENT_BY_REPORT_COLUMNS_RESULTS",
  DOWNLOAD_CONSOLIDATED_JSON: "DOWNLOAD_CONSOLIDATED_JSON",
  DOWNLOAD_CONSOLIDATED_JSON_RESULTS: "DOWNLOAD_CONSOLIDATED_JSON_RESULTS",
  MESSAGING_LIST: "MESSAGING_LIST",
  MESSAGING_LIST_RESULT: "MESSAGING_LIST_RESULT",
  UPDATE_SEARCH_FOR_GENERATED_INVOICES_QUERY: "UPDATE_SEARCH_FOR_GENERATED_INVOICES_QUERY",
  UPDATE_SEARCH_FOR_INVOICE_TEMPLATES_QUERY: "UPDATE_SEARCH_FOR_INVOICE_TEMPLATES_QUERY",
} as const;
